<template>
    <div class="page-body">
        <div class="page-content">
            <div class="page-left-nav">
                <ComLeftNav />
            </div>
            <div class="page-right main-body">
                <ComEdit :contentType="'video'" />
            </div>
        </div>
    </div>
</template>
<script>
    import {
        defineComponent,
        onMounted,
    } from "vue";


    import ComLeftNav from "./ComLeftNav.vue";
    import ComEdit from "./ComEdit.vue";

    export default defineComponent({
        components: {
            ComLeftNav,
            ComEdit
        },
        setup() {

            // 初始化
            onMounted(() => {

            });

            return {};
        },
    });
</script>

<style scoped lang="less">
    .page-body {
        padding-top: 120px;
        background-color: #ECECEC;
        min-height: 100vh;

        .page-content {
            width: 80%;
            margin: 0 10%;
            display: flex;

            .page-left-nav {
                width: 340px;

                .nav-top {
                    font-size: 24px;
                    color: #fff;
                    background-color: #CB5520;
                    line-height: 70px;
                    text-align: center;
                }

                .nav-content {
                    .nav-list-box {
                        min-height: 600px;
                        background: url('~@/assets/img/s_2.png') no-repeat center;
                        padding-top: 50px;

                        .nav-list-item {
                            cursor: pointer;
                            width: 220px;
                            line-height: 56px;
                            text-align: center;
                            height: 56px;
                            font-size: 18px;
                            margin: 0 auto;
                            color: #333;
                            margin-bottom: 10px;
                        }

                        .active {
                            background: url('~@/assets/img/s_title.png') no-repeat center;
                        }
                    }
                }
            }

            .page-right {
                flex: 1;
                margin-left: 20px;
                background-color: #ffffff;
                padding: 20px;
            }
        }
    }
</style>